<div style="height: 100%; display: flex">
  <div style="flex-grow: 1; overflow: auto">
    <div style="height: 100%; overflow: auto">
      <hw-spinner [loading]="loading"></hw-spinner>
      <hw-iframe #preview [closable]="false"></hw-iframe>
    </div>
  </div>
  <hw-collapsible-panel width="200px" collapseSide="right" [collapsed]="false" *ngIf="attachments?.length > 0">
    <h4 style="padding: 10px 0 0 10px">{{ 'integration.doc-01.attachments' | translate }}:</h4>
    <div style="padding: 10px" *ngFor="let a of attachments">
      <a (click)="open(a)">{{ a.fileName }}</a>
    </div>
  </hw-collapsible-panel>
</div>
